import { usePrivateApiSupportedMutation } from '@services/WebApiService/ResellerSettingsApi';
import { useEffect } from 'react';
import useLocalStorage from '@hooks/useLocalStorage';
import { constant } from '@config/BaseSetting';

export default function usePrivateApiSupport() {
  const [accessToken] = useLocalStorage(constant.ACCESS_TOKEN_STORAGE);
  const [privateApiSupported, privateApiSupportedState] = usePrivateApiSupportedMutation();

  useEffect(() => {
    if (!privateApiSupportedState.isUninitialized) return;
    privateApiSupported({ accessToken });
  }, [privateApiSupportedState.isUninitialized]);

  return privateApiSupportedState.data?.data || false;
}
